/*                                          */
import { is_runes } from '../../context.js';
import { block } from '../../reactivity/effects.js';
import { hydrate_next, hydrating } from '../hydration.js';
import { BranchManager } from './branches.js';

/**
 *
 *
 *
 *
 *
 */
export function key(node, get_key, render_fn) {
	if (hydrating) {
		hydrate_next();
	}

	var branches = new BranchManager(node);

	var legacy = !is_runes();

	block(() => {
		var key = get_key();

		/*                                           */
		if (legacy && key !== null && typeof key === 'object') {
			key = /*            */ ({});
		}

		branches.ensure(key, render_fn);
	});
}
